import React from 'react'
import classnames from 'classnames';
// import './index.less';
import styled from './index._less';

interface IProps{
  icon: React.ReactNode,
  title: string,
  className?: string
}

const SiderBarItem: React.FC<IProps> = ({ icon, title, className }: IProps) => {
  return (
    <>
      <style jsx>{styled}</style>

      <div className={classnames('sider-bar-item-box', className)}>
        <div className="item-icon-box">
          { icon }
        </div>

        <p className="item-title-box">
          { title }
        </p>
      </div>
    </>
  )
}

export default SiderBarItem
